import React, { Fragment, useState } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useGlobalFilter
} from "react-table";
import { modifyCell, modifyCellHeader } from "./cell_formatter";
import Images from "../../utils/styles/images";
import Pagination from "./Pagination";

function Table({ columns, data, handleActionHeaderClick, handleSortHeader, handleActionClick,history}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: history.location.PageCurrent, pageSize: 10 }
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  

  return (
    <Fragment>
      
      <div className="funds-list-container">
        <table className="funds-table" {...getTableProps()}>
          <thead className="funds-head-container">
            {headerGroups.map(headerGroup => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className="funds-head-row"
              >
                {headerGroup.headers.map((column, i) => (
                  <th
                    // {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={`key-${i}`}
                    className="funds-header"
                    style={{ width: column.render("width") } }
                  >
                    {modifyCellHeader(
                      column.render("Header"),
                      handleActionHeaderClick,
                      handleSortHeader
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps} className="funds-table-body">
            {page.length <= 0 ? (
              <tr className="funds-table-empty-row">
                <td colSpan={14}>
                  <div className="funds-table-no-data">
                    <img src={Images.noData.board} alt="no-data-found-board" />
                    <p className="funds-table-no-data-header">
                      No result found
                    </p>
                    <p className="funds-table-no-data-body">
                      We couldn’t find what you are looking for.
                      <br /> Please try again.
                    </p>
                  </div>
                </td>
              </tr>
            ) : (
              page.map(row => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} className="funds-table-row">
                    {row.cells.map(cell => {
                      return (
                        <td {...cell.getCellProps()}
                         className="funds-cell">
                          {modifyCell(cell.render("Cell"), pageIndex, pageSize, handleActionClick)}

                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {/* {pageCount > 1 ? (
        <Pagination
          pageIndex={pageIndex}
          previousPage={previousPage}
          nextPage={nextPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          total={pageCount}
          gotoPage={gotoPage}
        />
      ) : null} */}
    </Fragment>
  );
}

export default Table;
